import React from 'react';
import { TextField } from '../../../TextField/TextField.js';

function SearchField(_ref) {
  var onChange = _ref.onChange,
      onClear = _ref.onClear,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      focused = _ref.focused,
      value = _ref.value,
      placeholder = _ref.placeholder,
      disabled = _ref.disabled,
      borderlessQueryField = _ref.borderlessQueryField;

  function handleChange(value) {
    onChange(value);
  }

  function handleClear() {
    if (onClear) {
      onClear();
    } else {
      onChange('');
    }
  }

  return /*#__PURE__*/React.createElement(TextField, {
    value: value,
    onChange: handleChange,
    onFocus: onFocus,
    onBlur: onBlur,
    label: placeholder,
    labelHidden: true,
    autoComplete: "off",
    focused: focused,
    placeholder: placeholder,
    clearButton: true,
    onClearButtonClick: handleClear,
    disabled: disabled,
    borderless: borderlessQueryField
  });
}

export { SearchField };